import { render } from "./SurveyLanguage.vue?vue&type=template&id=0e32f804&ts=true"
import script from "./SurveyLanguage.vue?vue&type=script&lang=ts"
export * from "./SurveyLanguage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__